import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { performanceEvaluationData } from '@app/shared/interfaces/vendor-management-model';
import { dropdownValues } from '@app/shared/interfaces/common.model';
import { PERFORMANCE_RATING_OPTIONS } from '@app/shared/constants/global.enum';

@Component({
  selector: 'app-performance-filter',
  templateUrl: './performance-filter.component.html',
  styleUrls: ['./performance-filter.component.scss']
})
export class PerformanceFilterComponent implements OnInit, OnChanges {
  VendorFilterForm!: FormGroup;
  openForm: boolean = true;
  @Input() performanceData: performanceEvaluationData[] = [];
  @Output() applyFilter = new EventEmitter<any>();
  @Output() applyFilterCriteria = new EventEmitter<{behaviouralRating?: number, techincalRating?: number, performanceRating?: string}>();
  @Output() resetFilter = new EventEmitter<any>();
  behaviouralRatingOptions: dropdownValues[] = [];
  technicalRatingOptions: dropdownValues[] = [];
  /** Fixed set — always the 6 buckets regardless of the data present. */
  performanceRatingOptions: dropdownValues[] = PERFORMANCE_RATING_OPTIONS.map(o => ({
    label: o.label,
    value: o.value,
  }));

  constructor() {}

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(): void {
    this.updateOptions();
  }

  private updateOptions(): void {
    if (!this.performanceData?.length) {
      this.behaviouralRatingOptions = [];
      this.technicalRatingOptions = [];
      return;
    }

    const getUniqueOptions = (key: keyof performanceEvaluationData) =>
      Array.from(
        new Set(
          this.performanceData
            ?.map((item) => item[key])
            ?.filter((val) => val !== null && val !== undefined),
        ),
      ).map((val) => ({ label: val.toString(), value: val.toString() }));

    this.behaviouralRatingOptions = getUniqueOptions('behaviouralRating');
    this.technicalRatingOptions = getUniqueOptions('techincalRating');
  }

  initializeForm(): void {
    this.VendorFilterForm = new FormGroup({
      behaviouralRating: new FormControl(null),
      techincalRating: new FormControl(null),
      performanceRating: new FormControl(null),
    });
  }

  reset(): void {
    this.VendorFilterForm.reset();
    this.openForm = false;
    setTimeout(() => {
      this.openForm = true;
    });
    this.resetFilter.emit(this.performanceData);
  }

  apply(): void {
    const { behaviouralRating, techincalRating, performanceRating } =
      this.VendorFilterForm.value;

    let filteredData = [...this.performanceData];
    if (behaviouralRating?.value) {
      filteredData = filteredData.filter(item => item.behaviouralRating === +behaviouralRating.value);
    }

    if (techincalRating?.value) {
      filteredData = filteredData.filter(item => item.techincalRating === +techincalRating.value);
    }

    if (performanceRating?.value) {
      filteredData = filteredData.filter(item => item.performanceRating === performanceRating.value);
    }

    const criteria = {
      behaviouralRating: behaviouralRating?.value ? +behaviouralRating.value : undefined,
      techincalRating: techincalRating?.value ? +techincalRating.value : undefined,
      performanceRating: performanceRating?.value ? String(performanceRating.value) : undefined,
    };

    this.applyFilter.emit(filteredData);
    this.applyFilterCriteria.emit(criteria);
  }
}
